// extracted by mini-css-extract-plugin
export default {"request-loader":"style_request-loader__VX241","requestLoader":"style_request-loader__VX241"};